import React from 'react'
import ContactCard from './ContactCard'
import { Typewriter } from 'react-simple-typewriter'
import { FaCalendarAlt, FaFacebookF, FaGithub, FaLinkedin, FaMapMarkerAlt, FaMobileAlt, FaRegEnvelopeOpen, FaWhatsapp } from 'react-icons/fa';
import { BiCloudDownload } from 'react-icons/bi'
const ProfileCard = () => {
  return (
    <section className='profile-card'>
      <div className="profile-card-img">
        <img src="/ahmed.jpg" alt="Ahmed Gabr" />
      </div>

      <div className="profile-card-content">
        <h1>Ahmed Gabr</h1>
        <span className="job-title">
          <Typewriter
            words={['Frontend Developer.', 'UI/UX Designer.', 'Graphic Designer.']}
            loop={true}
            cursor
            cursorStyle='|'
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1000}
          />
         </span>

        <div className="socail-link">
          <a href="https://www.facebook.com/desgbr" rel="noreferrer" target='_blank' className='facebook'>
            <FaFacebookF  />
          </a>
          <a href="https://www.linkedin.com/in/desgbr/" rel="noreferrer" target='_blank' className='linkedin'>
            <FaLinkedin  />
          </a>
          <a href="https://github.com/desgbr" rel="noreferrer" target='_blank' className='github'>
            <FaGithub  />
          </a>
          <a href="https://wa.me/+201120223494" rel="noreferrer" target='_blank' className='whatsapp'>
            <FaWhatsapp  />
          </a>
        </div>
        <div className="contacts-card">
          <ContactCard
            icon={<FaMobileAlt/>}
            title='Phone'
            link='tel:+201120223494'
            linkTitle='+2011 2022 3494'
            iconClass='mobile'
          />
          <ContactCard
            icon={<FaRegEnvelopeOpen/>}
            title='Email'
            link='mailto:ahmdgabrr@gmail.com'
            linkTitle='ahmdgabrr@gmail.com'
            iconClass='email'
          />
          <ContactCard
            icon={<FaMapMarkerAlt/>}
            title='Address'
            link='/'
            linkTitle='Asyut, Egypt'
            iconClass='address'
          />
          <ContactCard
            icon={<FaCalendarAlt/>}
            title='Birthday'
            link='/'
            linkTitle='13-9-1991'
            iconClass='date'
          />
        </div>

        <button className='download-cv-btn'>

          <BiCloudDownload/>
          <a href="ahmed-gabr-cv.pdf" download={'Ahmed_Gabr_CV_Reactjs_Developer.pdf'}>Download CV.</a>
        </button>
      </div>
    </section>
  )
}

export default ProfileCard